import React from 'react';
import './jds.css';

// Button do Jusfy DS. variant: filled | outlined | ghost.
// color: brand | neutral | error. size: md | sm.
export const JdsButton = React.forwardRef(function JdsButton(
  {
    variant = 'filled',
    color = 'brand',
    size = 'md',
    iconOnly = false,
    loading = false,
    type = 'button',
    className = '',
    children,
    disabled,
    ...rest
  },
  ref,
) {
  const cls = [
    'jds-btn',
    `jds-btn--${variant}`,
    `jds-btn--${color}`,
    size === 'sm' && 'jds-btn--sm',
    iconOnly && 'jds-btn--icon',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={cls}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="jds-btn__spinner" aria-hidden="true" />}
      {children}
    </button>
  );
});
